/**
 * Типи заходів — підпис для картки й для міні-гайда над календарем
 * (Calendar.jsx). Іконки лежать окремо, у common/EventTypeIcon: підпис і
 * форма іконки описують один тип, але потрібні в різних місцях.
 */
export const TYPE_LABELS = {
  Змагання: { ua: 'Змагання', en: 'Competition' },
  Збори: { ua: 'Збори', en: 'Meeting' },
  'Професійне навчання': { ua: 'Професійне навчання', en: 'Professional training' },
};

export const EVENT_TYPES = Object.keys(TYPE_LABELS);
